import { render } from "./UangTips.vue?vue&type=template&id=7344509e&ts=true"
import script from "./UangTips.vue?vue&type=script&lang=ts"
export * from "./UangTips.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__